import { ZoneId } from "@js-joda/core";
import { useUserState } from "store/user-store";

export const LEGACY_TZ_KEY = "_LEGACY_";

export const useDisplayTimezone = () => {
  return useUserState(state => state.getDisplayZoneId());
};

export const useCompanyTimezone = () => {
  return useUserState(state => state.getCompanyZoneId());
};

export type Timezones = {
  display: ZoneId;
  company: ZoneId;
};

export const useTimezone = (): Timezones => {
  const displayTz = useDisplayTimezone();
  const companyTz = useCompanyTimezone();

  return { display: displayTz, company: companyTz };
};
